export default {
  newDesign: true,
  title: "Escolha o melhor horário para uma aula gratuita – só 5 perguntas! | Kodland",
  downtimeUrl: "https://www.kodland.org/pt",
  ageRules: {
    min: 8,
    max: 13,
  },
  parameters: {
    landing_id: "BrQfwdTC",
    segment: 55,
  },
  startPage: {
    title:
      "Escolha o melhor horário para uma aula gratuita – só 5 perguntas!",
    subtitle:
      "💻 Vão adquirir experiência para trabalhar de forma criativa<br>💬 Desenvolve o pensamento criativo e a socialização<br>🌐 Você só precisa de um computador e internet<br>💙 Mais de 100.000 alunos formados em todo o mundo",
    image: {
      url: "/welcome/fwd_freetc_br_desktop.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/fwd_freetc_br_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Reserve sua vaga 🔥 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Obrigado por confiar na nossa plataforma educativa!",
    subtitle:
      "Infelizmente, tablets ou celulares não são adequados para participar das nossas aulas.Ficaremos felizes em vê-los nas nossas próximas aulas!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Você gostaria que o tempo que seu filho(a) passa no computador fosse mais produtivo?",
      answers: [
        "🔥 Sim!",
        "🤷 Não. Ele(a) faz isso só por diversão e está tudo bem",
      ],
    },
    2: {
      title: "Quantos anos seu filho(a) tem?",
      type: "age",
      button: "",
    },
    3: {
      question: "O que mais chama a atenção do seu filho(a)?",
      answers: [
        "🎨 Desenho e ilustração",
        "✏️ Design e criatividade digital",
        "🎬 Animação e vídeo",
        "🌍 Mundos 3D e personagens",
        "🖌️ Quadrinhos e mangá",
        "🚀 Modelagem 3D profissional",
      ],
    },
    4: {
      question:
        "Neste momento, o que é mais importante para você no desenvolvimento do seu filho(a)?",
      answers: [
        "🤔 Habilidades sociais e emocionais",
        "🎓 Preparação para uma carreira no futuro",
        "💻 Atividades extracurriculares",
      ],
    },
    5: {
      question:
        "Você tem um computador de mesa ou notebook com o qual seu filho pode estudar?",
      answers: [
        "💻 Sim",
        {
          answer: "😐 Não",
          stopAnswer: true,
        },
      ],
    },
    6: {
      title: "Parabéns! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Estamos muito felizes em receber seu filho(a) na nossa aula gratuita online de Criatividade Digital.",
      button: "Finalizar inscrição",
    },
    7: {
      title: "Agende uma aula gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Quase lá! 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title: "Revise estes detalhes para completar a inscrição ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Lembre-se de que será necessário ter um PC ou notebook em funcionamento e que você deverá acompanhar seu filho(a) durante toda a aula. A aula é individual e personalizada.",
      button: "O que mais?",
    },
    10: {
      title: "Confira seu e-mail e WhatsApp antes da aula experimental 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Enviaremos um lembrete 24h antes e, 2 horas antes da aula, pediremos que confirme sua presença. É muito importante que estejamos em contato para que a aula não seja cancelada.",
      button: "O que mais?",
    },
    11: {
      title: "A aula vai acontecer na nossa plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Você vai receber um link e um código único pelo WhatsApp e e-mail. Basta clicar no link, ele vai te levar direto para a aula. Sem aplicativos extras, sem downloads.",
      button: "Entendi ✅",
    },
  },
};
